type Win = typeof window;

const LAST_SLASH_RX = /\/$/;
export const getChapterIndexURL = ({
    window,
    resourceURL,
    chapterName,
    region,
}: {
    window: Win;
    resourceURL: string;
    chapterName: string;
    region: string;
}) => {
    const pathToIndexHTML = [
        resourceURL.replace(LAST_SLASH_RX, ''),
        region,
        chapterName,
    ].join('/');

    // make path absolute if it's not already
    const baseURL = new window.URL(pathToIndexHTML, window.location.href).href;
    return {
        baseURL,
        chapterURL: `${baseURL}/index.html`,
    };
};
